import { Type } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkerResult } from './import.model';

export class WizardImportConfig {
  welcomePage: WizardImportPage;
  contentPages: WizardImportContentPage[];
  transferObject: object;
  importFileNameSchema: string;
  startImportWorker: (transferObject: object) => Observable<WorkerResult>;

  static readonly TimeStamp_Placeholder: string = '{timestamp}';
  constructor() {
    this.welcomePage = new WizardImportPage();
    this.contentPages = new Array<WizardImportContentPage>();
    this.importFileNameSchema = 'Import_' + WizardImportConfig.TimeStamp_Placeholder + '.xml';
  }
}

export class WizardImportPage {
  title: string;
  description: string;
  constructor() {}
}

export class WizardImportContentPage extends WizardImportPage {
  component: Type<unknown>;
  componentInstance: IWizardImportPageComponent;
  constructor() {
    super();
  }
}

export interface IWizardImportPageComponent {
  transferObject: object;
  readonly isValid: boolean;
  readonly invalidMessage: string;
  onNext(): void;
}
